import { useSEO, breadcrumb, faqSchema } from "../lib/seo";
import { SITE } from "../lib/site";
import PageHero from "../components/PageHero";
import { FAQS } from "../data/faq";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

export default function FAQ() {
  useSEO({
    title: "FAQ Sloto69 | Pertanyaan Umum Pengguna",
    description: "Jawaban atas pertanyaan umum tentang Sloto69: cara login, daftar, link alternatif, keamanan, dan dukungan pengguna.",
    keywords: "faq sloto69, pertanyaan sloto69, bantuan sloto69",
    canonical: `${SITE.baseUrl}/faq`,
    jsonLd: [
      breadcrumb([
        { name: "Beranda", url: `${SITE.baseUrl}/` },
        { name: "FAQ", url: `${SITE.baseUrl}/faq` },
      ]),
      faqSchema(FAQS),
    ],
  });

  return (
    <>
      <PageHero
        eyebrow="Pertanyaan Umum"
        title="Jawaban atas Pertanyaan-Pertanyaan Populer Pengguna"
        description="Berikut adalah ringkasan pertanyaan yang paling sering diajukan oleh pengguna Sloto69."
        breadcrumb={[{ label: "FAQ" }]}
      />

      <section className="section-pad" data-testid="faq-page">
        <div className="shell max-w-4xl">
          <Accordion type="single" collapsible className="grid gap-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`faq-${i}`}
                data-testid={`faq-page-item-${i}`}
                className="card-premium px-5 border-0"
              >
                <AccordionTrigger className="text-left font-display text-base sm:text-lg hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-300 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </>
  );
}
